import { GraphQLObjectType, GraphQLNonNull, GraphQLInt } from 'graphql'

export interface LicenseBreakdown {
  readonly used: number
  readonly unused: number
}

export const LicenseBreakdownType = new GraphQLObjectType({
  name: 'LicenseBreakdown',
  fields: () => ({
    used: {
      description: 'How many licenses have already been consumed',
      type: new GraphQLNonNull(GraphQLInt)
    },
    unused: {
      description: 'How many licenses are still available',
      type: new GraphQLNonNull(GraphQLInt)
    }
  })
})
